export const menuListDocente = [
  {
    title: 'Relatórios',
    icon: 'paper',
    link: '/docente/relatorios',
    color: 'red'
  },
  {
    title: 'Lista de bolsistas',
    icon: 'list',
    link: '/docente/lista',
    color: 'yellow'
  },
  {
    title: 'Bolsas expiradas',
    icon: 'cancel',
    link: '/docente/bolsas/expiradas',
    color: 'blue'
  }
]
